import { RawDiscoursePageData, RawInputPageData, RawPageData, SFFProblemType } from "../../../its-pages/src";

export function generateConfusionKey(
  skill: string, tagA: string, tagB: string, version: string | undefined
) {
    const tagIds = [tagA, tagB].sort(
      (a, b) => (a > b ? 1 : -1)
    );
    return generateCardKey(skill, '', tagIds.join('-'), version);
  }

export function generateCardKey(
    skill: string,
    type: SFFProblemType | '',
    tag: string,
    version: string | undefined
  ) {
    const cardKey = `${skill}:${type}:${tag}`;
    if (version) {
      return `${cardKey}:${version}`;
    }
    return cardKey;
  };

export type CardEventId = string | undefined;

export type CardIssueCallback =
  (
    cardKey: string,
    tagId: string,
    questionType: string,
    userId: string) => void;
export type CardConfusionCallback =
  (
    cardKey: string,
    tagAId: string,
    tagBId: string,
    questionType: string,
    userId: string,
    correct: boolean) => void;
export type CardEvalCallback = (
  cardKey: string,
  questionType: string,
  userId: string,
  correct: boolean
) => void;

export function processEvent(
  event: RawPageData,
  moduleVersion: string | undefined,
  issueCardCallback: CardIssueCallback,
  confusionCardCallback: CardConfusionCallback,
  evalCardCallback: CardEvalCallback
) {
  const { skill, type, playStats } = event;
  if (playStats) {
    const { userId, tagResults } = playStats;
    tagResults.forEach((tagResult) => {
      // Ignore correct responses for a submission (using this to display errors in dashboard)
      if (tagResult.correct) {
        return;
      }

      const issueCardKey = generateCardKey(skill.id, type, tagResult.tagId, moduleVersion);
      issueCardCallback(issueCardKey, tagResult.tagId, type, userId);
    });

    if (type === SFFProblemType.Type3 || type === SFFProblemType.Type4) {
      const inputData = event as RawInputPageData;
      const options = inputData.options;

      options?.forEach((optionProcessing) => {
        optionProcessing.tagData

        const options = inputData.options;
        // only process the options that are part of the desired answer
        if (!optionProcessing?.correct) {
          return;
        }

        options.forEach((optionOther) => {
          // Only compare the current option that is correct with the other options that
          // are incorrect.
          if (optionOther === optionProcessing || optionOther.correct) {
            return;
          }

          optionProcessing.tagData.forEach((tagProcessing) => {
            optionOther.tagData.forEach((tag) => {
              if (tagProcessing.id === tag.id) {
                return;
              }

              const tagIds = [tagProcessing.id, tag.id].sort(
                (a, b) => (a > b ? 1 : -1)
              );

              const key = generateConfusionKey(skill.id, tagIds[0], tagIds[1], moduleVersion);
              // Check if user selected the incorrect option and not the correct option
              const userGotPairConfused = (!optionProcessing.selected && optionOther.selected) || false;
              confusionCardCallback(key, tagIds[0], tagIds[1], type, userId, !userGotPairConfused);
            });
          });
        });
      });
    } else if (type === SFFProblemType.Discourse) {
      // Discourse type questions are composed of multiple sub-questions
      const confusionKeysAlreadySeen = new Set<string>();
      const discourseEvent = event as RawDiscoursePageData;
      const { annotations, annotationOptions, playStats } = discourseEvent;
      if (annotationOptions && playStats) {
        // For discourse, tagResults tells us what option the user selected and whether it was the
        // correct one. Order is same as the annotations.
        // The annotation itself will indicate what the correct tag should be
        // If there is a mismatch we can do a comparison

        // Important to ignore, duplicate keys. If user got multiple annotations wrong with the same
        // confused tag pair, it should still only count as one question wrong
        // Increment each card key at most one time
        annotations.forEach((annotation, index) => {
          const userSelectedTag = playStats.tagResults[index];

          // If user picked incorrect option, increment a confusion key
          if (!userSelectedTag.correct) {
            const tagIds = [userSelectedTag.tagId, annotation.tag].sort(
              (a, b) => (a > b ? 1 : -1)
            );
            const key = generateConfusionKey(skill.id, tagIds[0], tagIds[1], moduleVersion);
            if (!confusionKeysAlreadySeen.has(key)) {
              confusionKeysAlreadySeen.add(key);
              confusionCardCallback(key, tagIds[0], tagIds[1], type, userId, false);
            }
          }
        });

        // We can compare to annotationOptions to generate all the card pairs
        /*for (const annotationKey in annotationOptions) {
          const optionsForOneDialog = annotationOptions[annotationKey];
          optionsForOneDialog.forEach((option) => {
          });
        }*/
      }
    } else if (type === SFFProblemType.SelfEval || type === SFFProblemType.PeerEval) {
      const evalCardKey = generateCardKey(skill.id, type, '', moduleVersion);
      evalCardCallback(evalCardKey, type, userId, true);
    }
  }
}